/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import styled, { keyframes } from 'styled-components';

import { colors } from '../../../../theme';

const loaderShimmer = keyframes`
    0% {
        background-position: -50px;
    }
    100% {
        background-position: 1150px;
    }
`;

export const ChartLoaderContainerStyled = styled.div`
    height: 0;
    position: relative;
`;

export const ChartLoaderStyled = styled.div.attrs({
    className: 'chart__loader',
})`
    position: absolute;
    z-index: 4;
    top: -1px;
    left: 0;
    height: 2px;
    width: 100%;
    overflow: hidden;
    backface-visibility: hidden;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-duration: 1.2s;
    animation-name: ${loaderShimmer};
    background: ${colors.tableLoaderBackgroundGradient};
`;
